import React from 'react';

import {
  ArrowBack as ArrowBackIcon,
  Description as DescriptionIcon,
  Assignment as AssignmentIcon,
} from '@mui/icons-material';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import type { LetterType } from './components/LetterTypeToggle';

export type { LetterType };

interface HeaderPaneProps {
  record: {
    id: string;
    clientName: string;
    clientNumber: string;
    letterType: LetterType;
    closeDate?: string;
    isExecuted?: boolean;
  };
}

const HeaderPane = ({ record }: HeaderPaneProps) => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <Stack direction="row" spacing={2} sx={{ mb: 3, alignItems: 'center' }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => void navigate(-1)}>
          Back
        </Button>
        <Box sx={{ flexGrow: 1 }} />
      </Stack>

      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        {record.letterType === 'engagement' ? (
          <DescriptionIcon sx={{ mr: 1, color: 'primary.main' }} />
        ) : (
          <AssignmentIcon sx={{ mr: 1, color: 'secondary.main' }} />
        )}
        <Typography variant="h4">{record.clientName}</Typography>
      </Box>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        Client Number: {record.clientNumber}
      </Typography>
      <Stack direction="row" spacing={1} sx={{ mb: 3 }}>
        <Chip
          label={record.letterType === 'engagement' ? 'Engagement Letter' : 'Waiver Letter'}
          color={record.letterType === 'engagement' ? 'primary' : 'secondary'}
        />
        {record.closeDate ? (
          <Chip label="Closed Client" color="default" />
        ) : (
          <Chip label="Active Matter" color="success" />
        )}
        {record.isExecuted && <Chip label="Executed" color="info" />}
      </Stack>
    </React.Fragment>
  );
};

export default HeaderPane;
